<template>
    <v-container style="padding-top: 80px !important">
        <div v-if="showcargando == true" id="cargando" style="z-index: 600;"
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
            <div class="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <p style="color: white;">Recibir Fianza</p>
            </v-card-title>
            <v-form ref="form" v-model="validForm" lazy-validation>
                <v-card-text>
                    <v-row justify="center">
                        <v-col cols="6" md="6">
                            <label class="typo__label" style="text-align: center;">¿El conductor coincide con el
                                afianzado?</label>
                            <br>
                            <label v-if="this.datosCorrespondencia.ficorrespondecond == 'S'"
                                class="typo__label font-weight-bold sub-Fia" style="text-align: center;">Si
                                coincide</label>
                            <label v-else class="typo__label font-weight-bold sub-Fia"
                                style="text-align: center; color: red;">No
                                coincide</label>
                            <v-divider class="margin"></v-divider>
                            <label class="typo__label" style="text-align: center;">Conductor:</label>
                            <br>
                            <label class="typo__label font-weight-bold sub-Fia" style="text-align: center;">
                                {{ this.datosCorrespondencia.svnomcond }}
                            </label>
                            <v-divider class="margin"></v-divider>
                            <template v-if="this.datosCorrespondencia.ficorrespondecond != 'S'">
                                <label class="typo__label" style="text-align: center;">Afianzado:</label>
                                <v-text-field v-model="datosBusqueda.Afianzado"
                                    v-on:blur="datosBusqueda.Afianzado = datosBusqueda.Afianzado != null ? datosBusqueda.Afianzado.trim() : null"
                                    outlined :rules="rulestext" maxlength="100" dense>
                                </v-text-field>
                            </template>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn class="ma-2" color="#536DFE" title="Datos Validos" @click="Recibir()"
                                :disabled="disabled">
                                <span style="color: white">Datos Validos</span>
                            </v-btn>
                            <v-btn title="Respuesta Invertida" class="ma-2" v-on:click="Invertir()" color="default"
                                :disabled="disabled">
                                Respuesta Invertida
                            </v-btn>
                            <v-btn color="error" class="ma-2" @click="cancelar()" :disabled="disabled">
                                Cancelar
                            </v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-row>
                </v-card-text>
            </v-form>
        </v-card>
    </v-container>
</template>
<script>
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import { mapState } from "vuex";
import DataTable from "@/components/pages/DataTableNet/DataTable";
import Menu from '@/components/pages/Contraloria/MenuRecuperaciones/MenuRecup.vue';
import Fianzas from '@/services/Fianzas/fianzas.service.js';
export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        DataTable,
        Menu
    },
    data() {
        return {
            datosBusqueda: {
                Afianzado: null,
            },
            rulestext: [
                v => {
                    if (v == null || v == '') {
                        return 'El campo es obligatorio'
                    }
                    else {
                        if (v.length < 3) {
                            return 'Mínimo 3 Carácteres'
                        }
                        else
                            return true
                    }
                },
            ],
            validForm: true,
            showcargando: true,
            datosCorrespondencia: [],
            showResp: false,
            datos: null,
            disabled: false
        }
    },
    watch: {
        'datosBusqueda.responsable'(val) {
            this.showResp = false;
        },
    },
    computed: {
        ...mapState(["domain", "informationPage", "permission"]),
    },
    methods: {
        async cancelar() {
            await MetodosGenerales.guardarEnSesionInfoReporte(this.datos, 'fianza');
            this.$router.push({ name: 'DetalleFianza' }).catch((error) => error);
        },
        async Invertir() {
            this.disabled = true;
            if (this.datosCorrespondencia.ficorrespondecond == "N") {
                this.$swal({
                    position: 'center',
                    title: 'Guardando datos...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: async () => {
                        this.$swal.showLoading();
                        let formData = new FormData();
                        formData.append("ficorrespondecond", this.datosCorrespondencia.ficorrespondecond);
                        formData.append("fiafianzado", this.datosCorrespondencia.svnomcond);
                        formData.append("afclave", this.datos.afclave);
                        formData.append("fifolio", this.datos.fifolio);
                        let data = await Fianzas.RecibirFianza(formData);
                        if (data) {
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Se invirtió la fianza correctamente',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                timer: 2500,
                            }).then(async () => {
                                await this.cancelar();
                            });
                        }
                        else {
                            this.$swal({
                                position: 'center',
                                icon: 'error',
                                title: 'Error',
                                text: 'Ocurrió un error, al inverti la fianza, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                            })
                            this.disabled = false;
                        }
                    }
                });
            }
            else {
                this.$swal({
                    position: 'center',
                    title: 'Guardando datos...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: async () => {
                        this.$swal.showLoading();
                        let formData = new FormData();
                        formData.append("afclave", this.datos.afclave);
                        formData.append("fifolio", this.datos.fifolio);

                        let data = await Fianzas.CambiarANoCorresponde(formData)
                        if (data) {
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Se invirtió la fianza correctamente',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                timer: 2500,
                            }).then(async () => {
                                await this.cancelar();
                            });
                        }
                        else {
                            this.$swal({
                                position: 'center',
                                icon: 'error',
                                title: 'Error',
                                text: 'Ocurrió un error, al invertir la fianza, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                            })
                            this.disabled = false;
                        }
                    }
                });
            }
        },
        async Recibir() {
            this.$refs.form.validate();
            if (this.$refs.form.validate()) {
                this.disabled = true;
                this.$swal({
                    position: 'center',
                    title: 'Guardando datos...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: async () => {
                        this.$swal.showLoading();
                        let formData = new FormData();
                        formData.append("ficorrespondecond", this.datosCorrespondencia.ficorrespondecond);
                        formData.append("fiafianzado", this.datosCorrespondencia.svnomcond);
                        formData.append("afclave", this.datos.afclave);
                        formData.append("fifolio", this.datos.fifolio);
                        let data = await Fianzas.RecibirFianza(formData);
                        if (data) {
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Se recibió la fianza correctamente',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                timer: 2500,
                            }).then(async () => {
                                await MetodosGenerales.guardarEnSesionInfoReporte(this.datos, 'fianza');
                                this.$router.push({ name: 'DetalleFianza' }).catch((error) => error);
                            });
                        }
                        else {
                            this.$swal({
                                position: 'center',
                                icon: 'error',
                                title: 'Error',
                                text: 'Ocurrió un error, al recibir la fianza, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                            })
                            this.disabled = false;
                        }
                    }
                });
            }
        },
    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", "15,317").then((response) => {
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 15)//acceso al módulo de contraloría Normativa 
                        this.permisoContraloria = true;
                    if (permiso.peclave == 317)//Permiso para fianzas
                        this.permisoFianzas = true;
                })

                if (!this.permisoContraloria || !this.permisoFianzas) {
                    this.$router.push({ name: `NoAutorizado` }).catch((error) => error);
                }
            } else {
                this.$router.push({ name: `NoAutorizado` }).catch((error) => error);
            }
        });
    },
    async mounted() {
        this.datos = await MetodosGenerales.obtenerSessionReporte('fianza');
        var formData = new FormData();
        formData.append("afclave", this.datos.afclave);
        formData.append("fifolio", this.datos.fifolio);
        let datoCorresp = await Fianzas.ObtenerCorrespondencia(formData);
        this.datosCorrespondencia = datoCorresp.length > 0 ? datoCorresp[0] : {
            ficorrespondecond: 'N',
            svnomcond: null
        }
        this.showcargando = false;
    },
}
</script>

<style scoped>
.margin {
    margin: 2vh 0;
}
</style>
